import { Modal } from '@mantine/core';
import React from 'react';

import ModalHeader from 'components/ModalHeader';
import { User } from 'types';

import ResetPasswordForm from './ResetPasswordForm';

type EditProfileModalProps = {
  opened: boolean;
  onClose: () => void;
  user: User;
};

function ResetPasswordModal({ opened, onClose, user }: EditProfileModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Reset Password"
        onClose={onClose}
        ariaLabel="Close reset password modal"
      />
      <ResetPasswordForm user={user} onClose={onClose} />
    </Modal>
  );
}

export default ResetPasswordModal;
